 <template>
    <div class="intro-page">
        <div class="page-header">中医体质养生介绍</div>
        <div class="tizhi-page">
            <p class="page-text">中医体质养生机器人由中国中医科学院中医药信息研究所与广州华见智能科技有限公司联合研发。是集体质辨识与养生知识库于一体的软硬件集成应用服务平台。</p>
            <p class="page-text">机器人通过摄像头采集用户的面部和舌苔图像特征值，自动识别体质类型，显示用户体质的具体表现，以及生病倾向，进而给出体质类型和相应的中医专家建议的调理方案。如果想查看更多名医的调理方案，可以访问中医养生知识平台。</p>
            <p class="page-text">中医养生知识平台采用国际先进的互联网和知识库等技术，对中医养生学知识进行系统整理和现代诠释，研发综合性的中医养生知识库，面向普通百姓，实现高级检索、分类导航、图形化浏览和内容展示等功能。</p>
        </div>
        <div class="page-info">
            <el-carousel class="customize-list" indicator-position="outside" :interval="5000" type="card" height="320px">
                <el-carousel-item  class="list" v-for="(item,index) in customizeList" :key="index">
                    <div class="list-pic">
                        <img :class="item.type=='height'?'img-height':'img-width'" :src="item.pic" alt="">
                    </div>
                </el-carousel-item>
            </el-carousel> 
            <div class="page-info"> 
            <ul>
                <li class="info-list">
                    <p class="list-tit"><span class="icon"></span>中医体质自动辨识</p>
                    <div class="list-txt">通过摄像头对使用者进行面部、舌苔望诊，自动识别用户体质类型，显示用户体质具体表现及可能存在发病倾向，进而给出相应中医专家的调理建议，以食疗辅助结合身体运动为主。同时，机器人能根据用户的健康状况，生成对应的治疗处方供医生参考，以上整个识别判断过程不超过1分钟，机器人的速度与精准度符合当前快速发展的社会需求。</div>
                </li>
                <li class="info-list">
                    <p class="list-tit"><span class="icon"></span>情绪识别</p>
                    <div class="list-txt"> 为更全面地改善健康问题，中医体质养生机器人系统中增加了的情绪识别功能（情绪即中医的情智，研究表明情智能影响人体的免疫力，能治疗或会导致疾病的产生）。机器人通过面部信息采集，识别用户的内心情绪并给出相应建议，协助调整影响身心健康的不良情绪。 </div>
                </li>
                <li class="info-list">
                    <p class="list-tit"><span class="icon"></span>养生知识体系</p>
                    <div class="list-txt">  
                        <p>对中医养生领域的知识体系进行分析和梳理，建立了中医养生知识分类框架。根据中医养生学知识体系的特点，将中医养生知识分为中医养生基础、中医养生方法、中医养生应用三个大类，从理论、方法到应用的三个层面上解析养生知识，再对每个大类进行进一步细分，从而建立了中医养生知识分类的总体框架。</p> 
                         <el-row :gutter="20" class="txt-img">
                            <el-col :span="12">
                                <img src="../../assets/images/tz6.jpg" alt="">
                            </el-col>
                            <el-col :span="12"> 
                                <img src="../../assets/images/tz7.jpg" alt="">
                            </el-col>
                        </el-row>
                        <!-- <div class="txt-img">
                            <img src="../../assets/images/tz6.jpg" alt="">
                            <img src="../../assets/images/tz7.jpg" alt="">
                        </div> -->
                    </div>
                </li> 
            </ul>
        </div>
        </div> 
        <introFooter></introFooter>
    </div>
</template>

<script>
import introFooter from './intro_footer.vue'
export default {
    components: {
        introFooter,
    },
    data () {
        return {
            customizeList:[
                {
                    pic:require('../../assets/images/tz1.jpg'), 
                    type:'height',
                },
                {
                    pic:require('../../assets/images/tz2.jpg'), 
                    type:'height',
                },
                {
                    pic:require('../../assets/images/tz3.jpg'), 
                    type:'width',
                },
                {
                    pic:require('../../assets/images/tz4.jpg'), 
                    type:'width',
                },
                {
                    pic:require('../../assets/images/tz5.jpg'), 
                    type:'width',
                },
            ]
        }
    }
}
</script>


<style lang="less"> 
    @import url('../../css/intro_page.less');  
    
</style>